import {axiosNodeClient} from "../http";

export const bookingServiceNode = {create, getStaffs, getServicesInStaff, getServicesInStaffV2, getStore}


function getStore(storeId) {
    return axiosNodeClient.get(`/booking/${storeId}/store`);
}

function create(storeId, data) {
    return axiosNodeClient.post(`/booking/${storeId}/create`, data);
}

function getStaffs(storeId) {
    return axiosNodeClient.get(`/booking/${storeId}/staffs`);
}

/**
 * Get services in one staff id
 */
function getServicesInStaff(storeId, staffId) {
    return axiosNodeClient.get(`/booking/${storeId}/services-in-staff`, {
        params: {
            staffId: staffId
        }
    });
}


/**
 * Get services in multi staff ids
 */
function getServicesInStaffV2(storeId, stafffIds) {
    return axiosNodeClient.get(`/booking/${storeId}/v2/services-in-staff`, {
        params: {
            staffIds: stafffIds.join()
        }
    });
}
